import styled from "styled-components";

export const ClearFilter = styled.p`
font-family: ${props => props.theme.fontFamily.helveticaNeue};
 font-size: ${props => props.theme.fontSize.primary};
  cursor: pointer;
  color: #006778;
    font-weight: ${props => props.theme.fontWeight.normal};
  font-style: : ${props => props.theme.fontWeight.normal};
  font-stretch: : ${props => props.theme.fontStretch.normal};
  line-height: ${props => props.theme.lineHeight.primary};
  letter-spacing: : ${props => props.theme.letterSpacing.normal};
  margin-bottom: 0px;

  text-decoration :underline;
  padding: 20px 0px;    
  @media (max-width: 991px) {
    font-size:14px;
    position:absolute;
    bottom:0;
    padding: 0px 0px; 
  }
`;

export const TabList = styled.ol`
display:flex;
align-items:center;
padding-left:20px;
list-style-type: none;
margin-bottom:0px;
@media (max-width: 991px) {

    display:block;
    padding:0px;
    padding-top:10px;
    .tab-list-active:after{
        pointer-events: none;
        border-color: transparent;
        
       
    }
  }


`;

export const TabContent = styled.li`
border: solid 1px #d4d4d4;
padding :5px 10px;
margin-left:10px;
cursor:pointer;
position: relative;
background-color:transparent;
display: flex;
align-items: center;

@media (max-width: 991px) {
    display:flex;
    justify-content:space-between;
    margin:10px 0px;
  }

`;


export const Count = styled.span`
 font-size: ${props => props.theme.fontSize.tertiary};
 letter-spacing: ${props => props.theme.letterSpacing.zero};
 background-color : ${props => props.theme.backgroundColor.primaryColor};
 color : ${props => props.theme.colors.white};
 font-style:  ${props => props.theme.fontWeight.normal};
 font-stretch:  ${props => props.theme.fontStretch.normal};
 font-family: ${props => props.theme.fontFamily.helveticaNeueMedium};
 text-align: center;
 margin: 0px 5px;
 padding:0 6px;
 border-radius: 50%;
 height:1.25rem;
 width:1.25rem;
 display: flex;
 justify-content: center;
 align-items: center;
 @media (min-width: 320px) and (max-width: 768px){
    font-family: ${props => props.theme.fontFamily.helveticaNeueMedium};
    font-size: ${props => props.theme.fontSize.secondary};
    letter-spacing: 0;
   }
`;

export const TopWrapper = styled.div`
display:flex;
justify-content : space-between;
margin:0px;

@media (max-width: 991px) {
    display:block;
  }
`;

export const TabsContainer = styled.div`
@media (max-width: 991px) {
    position:relative;
    padding-bottom:35px;
  }
`;

export const Tabtext = styled.span`
color:#505050;
font-family: ${props => props.theme.fontFamily.helveticaNeue};
 font-size: ${props => props.theme.fontSize.primary};
 font-style: : ${props => props.theme.fontWeight.normal};
 font-stretch: : ${props => props.theme.fontStretch.normal};
 line-height: ${props => props.theme.lineHeight.primary};
 letter-spacing: : ${props => props.theme.letterSpacing.normal};

 @media (max-width: 991px) {
  font-size:0.875rem;
}
`;

export const FilterText = styled.li`
color:#022737;
font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
 font-size: ${props => props.theme.fontSize.primary};
 font-style: : ${props => props.theme.fontWeight.normal};
  font-stretch: : ${props => props.theme.fontStretch.normal};
  line-height: ${props => props.theme.lineHeight.primary};
  letter-spacing: : ${props => props.theme.letterSpacing.normal};
  @media (max-width: 991px) {
    font-size:0.875rem;
  }
`;